import i18n from '@/locales/i18n'

const columns = [
    {
        title: i18n.t('locationList.factoryName'),
        dataIndex: "name",
        width: "180px",
        align: "center"
    },
    {
        title: i18n.t('locationList.address'),
        dataIndex: "address",
        width: "180px",
        align: "center"
    },   
    {
        title: i18n.t('locationList.contactName'),
        dataIndex: "locationContactName",
        width: "100px",
        align: "center",
        scopedSlots: {customRender: "locationContactName"}
    },
    {
        title: i18n.t('locationList.contactNumber'),
        dataIndex: "locationContactPhone",
        width: "100px",
        align: "center",
        scopedSlots:{customRender: "locationContactPhone"}
    },
    {
        title: i18n.t('edit'),
        dataIndex: 'editLocation',
        width: "120px",
        align: "center",
        scopedSlots: { customRender: 'editLocation' }
    },


    // {
    //     title: "ID",
    //     dataIndex: "id",
    //     width: "120px",
    //     align: "center"
    // },
    // {
    //     title: "所属平台公司账户",
    //     dataIndex: "companyId",
    //     width: "150px",
    //     align: "left"
    // },


    // {
    //     title: "地址类型",
    //     dataIndex: "locationType",
    //     width: "80px",
    //     align: "center",
    //     scopedSlots: { customRender: 'locationType' }
    // },
    // {
    //     title: "经度",
    //     dataIndex: "lat",
    //     width: "80px",
    //     align: "center"
    // },
    // {
    //     title: "纬度",
    //     dataIndex: "lon",
    //     width: "80px",
    //     align: "center"
    // },
    // {
    //     title: "创建时间",
    //     dataIndex: "createdTime",
    //     width: "120px",
    //     align: "center"
    // },
    // {
    //     title: "更新时间",
    //     dataIndex: "updatedTime",
    //     width: "120px",
    //     align: "center"
    // }
];


export {
    columns,
}